import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MajorService from "../../src/Services/Major.service";
const MajorLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return MajorService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MajorService.searchAll(search);
        },
        optionRenderer: function optionRenderer(major) {
            return (_jsxs("span", { children: ["(", major.acronym, ") ", major.name] }));
        },
    });
};
export default MajorLookup;
